import DashboardIcon from '@mui/icons-material/Dashboard';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ViewListIcon from '@mui/icons-material/ViewList';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseActionProps } from '../../actions/types';
import { HorizontalSelect } from '../HorizontalSelect';

type Props = BaseActionProps & {
  layout?: 'cards' | 'table' | 'board';
  handleClick?: (layout: 'cards' | 'table' | 'board') => void;
  isBoardEnabled: boolean;
};

export const LayoutHorizontalSelect: React.FC<Props> = (props) => {
  const { layout, handleClick, isBoardEnabled } = props;
  const { t } = useTranslation();

  const items = [
    {
      value: 'table',
      Icon: ViewHeadlineIcon,
      title: t('LISTS_PAGES.LAYOUT_LIST'),
    },
    {
      value: 'cards',
      Icon: ViewListIcon,
      title: t('LISTS_PAGES.LAYOUT_CARD'),
    },
  ];

  if (isBoardEnabled)
    items.push({
      value: 'board',
      Icon: DashboardIcon,
      title: t('LISTS_PAGES.LAYOUT_BOARD'),
    });

  return (
    <HorizontalSelect items={items} onClick={handleClick} value={layout} />
  );
};
